import { render, staticRenderFns } from "./hotel-dispoM.vue?vue&type=template&id=2c80559e"
import script from "./hotel-dispoM.vue?vue&type=script&lang=js"
export * from "./hotel-dispoM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports